import CONFIG from '../../globalVariables';

class AdminService {
  static async login(password) {
    const res = await fetch(`${CONFIG.PATH_API}/admin/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password })
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message || 'Login échoué');
    return data.token;
  }

  static async getTemplates(type = 'overall', token) {
    const res = await fetch(`${CONFIG.PATH_API}/admin/templates?type=${type}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message || 'Chargement templates échoué');
    return data.data;
  }

  static async uploadImage(file, token) {
    const form = new FormData();
    form.append('image', file);
    const res = await fetch(`${CONFIG.PATH_API}/admin/upload`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` },
      body: form
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message || 'Upload image échoué');
    return data.url;
  }

  static async updateProperty(type, section, property, contenu, token, categorieId = null) {
    const payload = { section, property, contenu };
    if (categorieId) payload.categorieId = categorieId;
    const res = await fetch(`${CONFIG.PATH_API}/admin/template/${type}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message || 'Mise à jour échouée');
    return data.data;
  }

  // NEW: update entire template by id
  static async updateTemplate(id, payload, token) {
    const res = await fetch(`${CONFIG.PATH_API}/admin/templates/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message || 'Mise à jour du template échouée');
    return data.data;
  }

  // ====== PAGES (PageContent) ======
  static async getPages(token) {
    const res = await fetch(`${CONFIG.PATH_API}/admin/pages`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message || 'Chargement des pages échoué');
    return data.data;
  }

  static async getPage(slug, token) {
    const res = await fetch(`${CONFIG.PATH_API}/admin/pages/${slug}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message || 'Chargement de la page échoué');
    return data.data;
  }

  static async upsertPage(payload, token) {
    const res = await fetch(`${CONFIG.PATH_API}/admin/pages`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message || 'Upsert de la page échoué');
    return data.data;
  }

  static async updatePage(id, payload, token) {
    const res = await fetch(`${CONFIG.PATH_API}/admin/pages/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message || 'Mise à jour de la page échouée');
    return data.data;
  }

  static async upsertPageSection(slug, section, token) {
    const res = await fetch(`${CONFIG.PATH_API}/admin/pages/${slug}/sections`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ section })
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message || 'Upsert section échoué');
    return data.data;
  }

  static async deletePageSection(slug, key, token) {
    const res = await fetch(`${CONFIG.PATH_API}/admin/pages/${slug}/sections/${key}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message || 'Suppression section échouée');
    return data.data;
  }
}

export default AdminService;
